mutation snoozeGrant($caseRecordId: ID!, $snoozedUntil: ISO8601Date!) {
  snoozeGrant(
    input: { caseRecordId: $caseRecordId, snoozedUntil: $snoozedUntil }
  ) {
    grantCaseRecord {
      id
    }
  }
}
